import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
} from "ngx-perfect-scrollbar";

import { CoreCommonModule } from "@core/common.module";
import { CoreTouchspinModule } from "@core/components/core-touchspin/core-touchspin.module";

import { NavbarComponent } from "app/layout/components/navbar/navbar.component";
import { NavbarBookmarkComponent } from "app/layout/components/navbar/navbar-bookmark/navbar-bookmark.component";
import { NavbarSearchComponent } from "app/layout/components/navbar/navbar-search/navbar-search.component";

import { NavbarNotificationComponent } from "app/layout/components/navbar/navbar-notification/navbar-notification.component";
import { SharedModule } from "app/main/shared/shared.module";
import { HelpGlobalButtonComponent } from "app/layout/components/navbar/navbar-help-button/navbar-help-button.component";
import { PlanProvisioningComponent } from "app/layout/components/plan-provisioning/plan-provisioning.component";
import { PlanConsumptionComponent } from "app/layout/components/plan-consumption/plan-consumption.component";
import { NavbarSupportHubspotComponent } from "./navbar-support-hubspot/navbar-support-hubspot.component";
import { NavbarCustomSupportComponent } from "./navbar-custom-support/navbar-custom-support.component";


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};

@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarNotificationComponent,
    HelpGlobalButtonComponent,
    PlanProvisioningComponent,
    PlanConsumptionComponent,
    NavbarSupportHubspotComponent,
    NavbarCustomSupportComponent
  ],
  imports: [
    RouterModule,
    NgbModule,
    CoreCommonModule,
    PerfectScrollbarModule,
    CoreTouchspinModule,
    SharedModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [NavbarComponent],
})
export class NavbarModule {}
